export const categories = [
  { slug: 'rexue', name: '热血', icon: 'ri-fire-line', count: 128, description: '激情澎湃的战斗与成长故事，点燃你的少年热血之魂' },
  { slug: 'maoxian', name: '冒险', icon: 'ri-compass-3-line', count: 96, description: '踏上未知的旅途，探索奇幻世界的无限可能' },
  { slug: 'gaoxiao', name: '搞笑', icon: 'ri-emotion-laugh-line', count: 85, description: '轻松幽默的日常故事，让你笑到停不下来' },
  { slug: 'qihuan', name: '奇幻', icon: 'ri-magic-line', count: 112, description: '魔法与异世界的奇妙碰撞，展开无尽的想象力' },
  { slug: 'lianai', name: '恋爱', icon: 'ri-heart-line', count: 74, description: '青涩甜蜜的校园恋爱，触动心弦的青春物语' },
  { slug: 'xuanyi', name: '悬疑', icon: 'ri-search-eye-line', count: 63, description: '扑朔迷离的案件与推理，挑战你的侦探头脑' },
  { slug: 'kehuan', name: '科幻', icon: 'ri-rocket-line', count: 58, description: '未来科技与星际冒险，开启超越想象的科幻之旅' },
  { slug: 'xiaoyuan', name: '校园', icon: 'ri-building-line', count: 91, description: '校园生活的点点滴滴，青春岁月的珍贵回忆' },
];

export const comics = [
  {
    id: 1,
    title: '龙魂少年',
    author: '李墨白',
    category: 'rexue',
    tags: ['热血', '冒险', '少年'],
    status: '连载中',
    rating: 9.6,
    views: 12580000,
    cover: 'https://readdy.ai/api/search-image?query=A%20dynamic%20manga%20cover%20featuring%20a%20young%20warrior%20with%20flaming%20dragon%20aura%2C%20intense%20action%20pose%2C%20vibrant%20warm%20red%20and%20orange%20color%20scheme%2C%20dramatic%20lighting%2C%20clean%20illustration%20style%20on%20simple%20background%2C%20Japanese%20shonen%20manga%20aesthetic&width=400&height=560&seq=comic-cover-01&orientation=portrait',
    description: '少年龙辰意外觉醒远古龙魂，从此踏上强者之路。在这个妖魔横行的世界，他必须在一次次生死战斗中不断突破自我，守护所爱之人。热血沸腾的战斗场面与感人至深的友情羁绊交织，一部不可错过的热血少年漫画！',
    updatedAt: '2026-08-05',
    chapters: [
      { num: 187, title: '龙魂觉醒·终章', updatedAt: '2026-08-05' },
      { num: 186, title: '最后的试炼', updatedAt: '2026-08-02' },
      { num: 185, title: '远古传承', updatedAt: '2026-07-30' },
      { num: 184, title: '突破极限', updatedAt: '2026-07-27' },
      { num: 183, title: '龙之咆哮', updatedAt: '2026-07-24' },
      { num: 182, title: '宿命对决', updatedAt: '2026-07-21' },
      { num: 181, title: '暗流涌动', updatedAt: '2026-07-18' },
      { num: 180, title: '新的征程', updatedAt: '2026-07-15' },
      { num: 179, title: '圣龙降临', updatedAt: '2026-07-12' },
      { num: 178, title: '深渊试炼', updatedAt: '2026-07-09' },
    ],
  },
  {
    id: 2,
    title: '星辰变',
    author: '我吃番茄',
    category: 'qihuan',
    tags: ['奇幻', '修仙', '冒险'],
    status: '连载中',
    rating: 9.4,
    views: 8960000,
    cover: 'https://readdy.ai/api/search-image?query=A%20fantasy%20manga%20cover%20showing%20a%20celestial%20cultivator%20floating%20among%20stars%20and%20galaxies%2C%20ethereal%20golden%20and%20silver%20energy%20surrounding%20him%2C%20mystical%20atmosphere%2C%20clean%20illustration%20style%20on%20dark%20cosmic%20background%2C%20xianxia%20manga%20aesthetic&width=400&height=560&seq=comic-cover-02&orientation=portrait',
    description: '秦羽，一个无法修炼内功的少年，凭借坚韧不拔的意志开创属于自己的修行之路。从凡间到仙界，从星辰大海到宇宙洪荒，他将以星辰之力撼动天地，书写一段不朽的传奇。改编自经典同名小说，画风精美大气。',
    updatedAt: '2026-08-04',
    chapters: [
      { num: 215, title: '星辰大海', updatedAt: '2026-08-04' },
      { num: 214, title: '宇宙之心', updatedAt: '2026-08-01' },
      { num: 213, title: '混沌初开', updatedAt: '2026-07-29' },
      { num: 212, title: '万界归一', updatedAt: '2026-07-26' },
      { num: 211, title: '鸿蒙掌控者', updatedAt: '2026-07-23' },
    ],
  },
  {
    id: 3,
    title: '校园风云录',
    author: '张小北',
    category: 'xiaoyuan',
    tags: ['校园', '搞笑', '日常'],
    status: '连载中',
    rating: 9.2,
    views: 7320000,
    cover: 'https://readdy.ai/api/search-image?query=A%20school%20life%20manga%20cover%20with%20a%20group%20of%20high%20school%20students%20in%20uniforms%20laughing%20together%20in%20a%20classroom%2C%20warm%20sunlight%20streaming%20through%20windows%2C%20cheerful%20atmosphere%2C%20clean%20illustration%20style%20on%20soft%20warm%20background%2C%20slice%20of%20life%20manga%20aesthetic&width=400&height=560&seq=comic-cover-03&orientation=portrait',
    description: '普通高中生林小凡，因为一系列乌龙事件成为了校园里的风云人物。从默默无闻到全校皆知，他经历了友情、懵懂爱情与成长的烦恼。轻松搞笑的日常故事中，藏着青春最美好的回忆。',
    updatedAt: '2026-08-05',
    chapters: [
      { num: 98, title: '毕业季', updatedAt: '2026-08-05' },
      { num: 97, title: '最后的考试', updatedAt: '2026-08-02' },
      { num: 96, title: '校园祭', updatedAt: '2026-07-30' },
      { num: 95, title: '告白', updatedAt: '2026-07-27' },
      { num: 94, title: '误会', updatedAt: '2026-07-24' },
    ],
  },
  {
    id: 4,
    title: '暗夜追踪',
    author: '陈暗影',
    category: 'xuanyi',
    tags: ['悬疑', '推理', '都市'],
    status: '连载中',
    rating: 9.5,
    views: 6540000,
    cover: 'https://readdy.ai/api/search-image?query=A%20suspense%20mystery%20manga%20cover%20with%20a%20detective%20in%20trench%20coat%20standing%20in%20a%20dark%20alley%20under%20streetlamp%2C%20moody%20noir%20atmosphere%2C%20shadows%20and%20silhouettes%2C%20clean%20illustration%20style%2C%20thriller%20manga%20aesthetic&width=400&height=560&seq=comic-cover-04&orientation=portrait',
    description: '退休刑警周寒收到一封神秘来信，将他卷入了一桩尘封二十年的连环案件。每一个线索都指向一个更大的阴谋，而真相远比想象中更加惊心动魄。紧张刺激的悬疑推理，让你欲罢不能！',
    updatedAt: '2026-08-03',
    chapters: [
      { num: 73, title: '真相大白', updatedAt: '2026-08-03' },
      { num: 72, title: '最后一块拼图', updatedAt: '2026-07-31' },
      { num: 71, title: '隐藏的证据', updatedAt: '2026-07-28' },
      { num: 70, title: '嫌犯现身', updatedAt: '2026-07-25' },
      { num: 69, title: '突破性进展', updatedAt: '2026-07-22' },
    ],
  },
  {
    id: 5,
    title: '机械纪元',
    author: '铁心兰',
    category: 'kehuan',
    tags: ['科幻', '机甲', '未来'],
    status: '连载中',
    rating: 9.3,
    views: 5890000,
    cover: 'https://readdy.ai/api/search-image?query=A%20sci-fi%20mecha%20manga%20cover%20with%20a%20giant%20robot%20standing%20in%20a%20futuristic%20city%2C%20pilot%20in%20cockpit%20visible%2C%20neon%20lights%20and%20holographic%20displays%2C%20clean%20illustration%20style%20on%20tech%20background%2C%20mecha%20anime%20aesthetic&width=400&height=560&seq=comic-cover-05&orientation=portrait',
    description: '公元2150年，人类文明进入机械纪元时代。少年驾驶员苏铁意外获得一台远古机甲，从此被卷入人类与人工智能之间的战争。宏大的世界观、炫酷的机甲设计，带来前所未有的科幻阅读体验！',
    updatedAt: '2026-08-04',
    chapters: [
      { num: 156, title: '觉醒之日', updatedAt: '2026-08-04' },
      { num: 155, title: '最终防线', updatedAt: '2026-08-01' },
      { num: 154, title: '人类反击', updatedAt: '2026-07-29' },
      { num: 153, title: 'AI之主', updatedAt: '2026-07-26' },
      { num: 152, title: '机甲之心', updatedAt: '2026-07-23' },
    ],
  },
  {
    id: 6,
    title: '恋爱物语',
    author: '漫画家小甜',
    category: 'lianai',
    tags: ['恋爱', '校园', '青春'],
    status: '已完结',
    rating: 9.1,
    views: 10120000,
    cover: 'https://readdy.ai/api/search-image?query=A%20romance%20manga%20cover%20with%20a%20boy%20and%20girl%20standing%20under%20cherry%20blossom%20tree%2C%20soft%20pink%20petals%20falling%2C%20gentle%20spring%20lighting%2C%20clean%20illustration%20style%20on%20pastel%20background%2C%20shoujo%20manga%20aesthetic&width=400&height=560&seq=comic-cover-06&orientation=portrait',
    description: '转学生叶樱与隔壁班的篮球少年顾晨，在樱花树下的一次偶然相遇，开启了一段青涩甜蜜的恋爱故事。从相识到相知，从误会到释然，每一个瞬间都让人心动不已。温暖治愈的纯爱漫画，献给每一个相信爱情的你。',
    updatedAt: '2026-07-20',
    chapters: [
      { num: 120, title: '永远在一起（大结局）', updatedAt: '2026-07-20' },
      { num: 119, title: '樱花之约', updatedAt: '2026-07-17' },
      { num: 118, title: '真心话', updatedAt: '2026-07-14' },
      { num: 117, title: '毕业前夕', updatedAt: '2026-07-11' },
      { num: 116, title: '共同的未来', updatedAt: '2026-07-08' },
    ],
  },
  {
    id: 7,
    title: '仙界传说',
    author: '云中君',
    category: 'qihuan',
    tags: ['奇幻', '修仙', '搞笑'],
    status: '连载中',
    rating: 9.0,
    views: 7780000,
    cover: 'https://readdy.ai/api/search-image?query=A%20cultivation%20fantasy%20manga%20cover%20with%20a%20young%20immortal%20riding%20a%20sword%20through%20clouds%20above%20ancient%20Chinese%20mountains%2C%20flowing%20robes%2C%20mystical%20energy%2C%20clean%20illustration%20style%20on%20ethereal%20background%2C%20xianxia%20manhua%20aesthetic&width=400&height=560&seq=comic-cover-07&orientation=portrait',
    description: '一个来自现代的普通青年意外穿越到仙界，凭借现代知识与搞怪性格，在仙界掀起了一场欢乐风暴。修仙不一定严肃，搞笑也能成仙！轻松诙谐的修仙日常，带给你不一样的仙界体验。',
    updatedAt: '2026-08-05',
    chapters: [
      { num: 203, title: '仙帝归来', updatedAt: '2026-08-05' },
      { num: 202, title: '天劫降临', updatedAt: '2026-08-02' },
      { num: 201, title: '仙界大乱', updatedAt: '2026-07-30' },
      { num: 200, title: '突破！金仙', updatedAt: '2026-07-27' },
      { num: 199, title: '丹道宗师', updatedAt: '2026-07-24' },
    ],
  },
  {
    id: 8,
    title: '热血篮球',
    author: '灌篮高手工作室',
    category: 'rexue',
    tags: ['热血', '运动', '篮球'],
    status: '连载中',
    rating: 9.7,
    views: 14500000,
    cover: 'https://readdy.ai/api/search-image?query=A%20basketball%20sports%20manga%20cover%20with%20a%20player%20making%20a%20powerful%20dunk%20in%20a%20packed%20stadium%2C%20dramatic%20lighting%20from%20above%2C%20sweat%20and%20motion%2C%20clean%20illustration%20style%20on%20court%20background%2C%20sports%20shonen%20manga%20aesthetic&width=400&height=560&seq=comic-cover-08&orientation=portrait',
    description: '身高只有一米七的楚天河，凭借惊人的弹跳力和永不言弃的精神，带领默默无闻的晨曦高中篮球队一路杀入全国大赛。这是一部关于梦想、汗水与团队精神的热血运动漫画，每一个扣篮都让人热血沸腾！',
    updatedAt: '2026-08-04',
    chapters: [
      { num: 245, title: '全国大赛开幕', updatedAt: '2026-08-04' },
      { num: 244, title: '最后特训', updatedAt: '2026-08-01' },
      { num: 243, title: '对手分析', updatedAt: '2026-07-29' },
      { num: 242, title: '晋级之路', updatedAt: '2026-07-26' },
      { num: 241, title: '王者归来', updatedAt: '2026-07-23' },
    ],
  },
  {
    id: 9,
    title: '深海迷踪',
    author: '海洋之心',
    category: 'maoxian',
    tags: ['冒险', '奇幻', '海洋'],
    status: '连载中',
    rating: 9.2,
    views: 5230000,
    cover: 'https://readdy.ai/api/search-image?query=An%20adventure%20manga%20cover%20showing%20a%20young%20diver%20discovering%20an%20ancient%20underwater%20ruin%2C%20mysterious%20glowing%20creatures%2C%20deep%20blue%20ocean%20gradient%2C%20clean%20illustration%20style%2C%20adventure%20manga%20aesthetic&width=400&height=560&seq=comic-cover-09&orientation=portrait',
    description: '海洋生物学研究生江小鱼在一次深海考察中，意外发现了传说中亚特兰蒂斯的遗迹。随着探索的深入，一个关于人类文明起源的巨大秘密逐渐浮出水面。宏大的海底世界观与精美的画面，带你潜入深海的奇幻冒险！',
    updatedAt: '2026-08-03',
    chapters: [
      { num: 89, title: '亚特兰蒂斯之心', updatedAt: '2026-08-03' },
      { num: 88, title: '海底文明', updatedAt: '2026-07-31' },
      { num: 87, title: '远古守卫', updatedAt: '2026-07-28' },
      { num: 86, title: '深渊之门', updatedAt: '2026-07-25' },
      { num: 85, title: '失落的城市', updatedAt: '2026-07-22' },
    ],
  },
  {
    id: 10,
    title: '搞笑天团',
    author: '乐翻天',
    category: 'gaoxiao',
    tags: ['搞笑', '日常', '校园'],
    status: '连载中',
    rating: 9.3,
    views: 8670000,
    cover: 'https://readdy.ai/api/search-image?query=A%20comedy%20manga%20cover%20with%20four%20exaggerated%20funny%20characters%20making%20silly%20faces%2C%20colorful%20and%20vibrant%2C%20comic%20sound%20effects%2C%20clean%20illustration%20style%20on%20bright%20playful%20background%2C%20gag%20manga%20aesthetic&width=400&height=560&seq=comic-cover-10&orientation=portrait',
    description: '四个性格迥异的少年组成了一个"搞笑天团"，他们的目标是——让全校师生每天都笑出声！各种无厘头的搞笑日常、令人捧腹的误会与意外，保证让你从头笑到尾。减压神作，快乐源泉！',
    updatedAt: '2026-08-05',
    chapters: [
      { num: 134, title: '天团大作战', updatedAt: '2026-08-05' },
      { num: 133, title: '运动会风云', updatedAt: '2026-08-02' },
      { num: 132, title: '学园祭', updatedAt: '2026-07-30' },
      { num: 131, title: '考试大作战', updatedAt: '2026-07-27' },
      { num: 130, title: '合宿噩梦', updatedAt: '2026-07-24' },
    ],
  },
  {
    id: 11,
    title: '时空旅人',
    author: '时光机',
    category: 'kehuan',
    tags: ['科幻', '穿越', '冒险'],
    status: '已完结',
    rating: 9.4,
    views: 6980000,
    cover: 'https://readdy.ai/api/search-image?query=A%20time%20travel%20sci-fi%20manga%20cover%20with%20a%20young%20man%20stepping%20through%20a%20portal%20between%20different%20time%20periods%2C%20clock%20gears%20and%20hourglass%20motifs%2C%20clean%20illustration%20style%20on%20cosmic%20background%2C%20sci-fi%20manga%20aesthetic&width=400&height=560&seq=comic-cover-11&orientation=portrait',
    description: '物理系天才陆时获得了一台能够穿越时空的神秘装置，从此开启了一段跨越千年的冒险之旅。从古代王朝到未来世界，他见证了历史的变迁，也试图改变注定的悲剧。烧脑的时间线，感人至深的故事！',
    updatedAt: '2026-06-15',
    chapters: [
      { num: 88, title: '时空终点（大结局）', updatedAt: '2026-06-15' },
      { num: 87, title: '永恒的瞬间', updatedAt: '2026-06-12' },
      { num: 86, title: '最后的机会', updatedAt: '2026-06-09' },
      { num: 85, title: '时间的代价', updatedAt: '2026-06-06' },
      { num: 84, title: '平行世界', updatedAt: '2026-06-03' },
    ],
  },
  {
    id: 12,
    title: '武道至尊',
    author: '武道传承人',
    category: 'rexue',
    tags: ['热血', '武术', '格斗'],
    status: '连载中',
    rating: 9.5,
    views: 9870000,
    cover: 'https://readdy.ai/api/search-image?query=A%20martial%20arts%20manga%20cover%20with%20a%20young%20fighter%20in%20dynamic%20combat%20stance%2C%20energy%20aura%20bursting%2C%20traditional%20Chinese%20martial%20arts%20setting%2C%20clean%20illustration%20style%20on%20dramatic%20background%2C%20wuxia%20manhua%20aesthetic&width=400&height=560&seq=comic-cover-12&orientation=portrait',
    description: '在这个以武为尊的世界里，少年武阳身怀绝世根骨却因家族被灭而隐姓埋名。十年磨一剑，当他重新踏上武道之路，誓要以一双铁拳打出一片天。酣畅淋漓的打斗场面，每一拳都震撼人心！',
    updatedAt: '2026-08-04',
    chapters: [
      { num: 178, title: '至尊之战', updatedAt: '2026-08-04' },
      { num: 177, title: '武道巅峰', updatedAt: '2026-08-01' },
      { num: 176, title: '终极奥义', updatedAt: '2026-07-29' },
      { num: 175, title: '王者对决', updatedAt: '2026-07-26' },
      { num: 174, title: '突破瓶颈', updatedAt: '2026-07-23' },
    ],
  },
];

export const featuredComicIds = [8, 1, 12, 4, 11];

export const popularComicIds = [8, 1, 6, 12, 4, 2, 10, 7, 3, 5, 9, 11];

export const latestComicIds = [1, 7, 10, 3, 8, 12, 2, 5, 4, 9, 6, 11];

export const faqData = [
  {
    question: '蜜桃少年漫画是什么？',
    answer: '蜜桃少年漫画是178漫画网旗下的少年向漫画阅读平台，提供海量热血、冒险、搞笑、奇幻等类型漫画，全部免费阅读、无删减、高清画质，支持下拉式流畅阅读体验。',
  },
  {
    question: '漫画多久更新一次？',
    answer: '热门连载漫画通常每周更新2-3话，具体更新频率因作品而异。您可以在每部漫画的详情页查看最新的更新时间和更新频率信息。',
  },
  {
    question: '需要注册账号才能阅读吗？',
    answer: '不需要！蜜桃少年漫画所有内容完全免费，无需注册即可直接阅读。我们致力于为所有漫画爱好者提供最便捷的阅读体验。',
  },
  {
    question: '漫画画质清晰吗？',
    answer: '我们提供高清画质的漫画内容，所有漫画均经过专业处理，确保画面清晰锐利，让您享受最佳的阅读体验。支持自适应分辨率，在不同设备上都能获得出色的显示效果。',
  },
  {
    question: '如何找到我想看的漫画？',
    answer: '您可以通过首页的分类导航、搜索功能或热门排行来找到感兴趣的漫画。我们提供热血、冒险、搞笑、奇幻、恋爱、悬疑、科幻、校园等多种分类，方便您快速浏览。',
  },
  {
    question: '手机可以看漫画吗？',
    answer: '当然可以！蜜桃少年漫画完美适配手机、平板和电脑等各类设备。下拉式阅读方式在手机上体验尤为流畅，随时随地享受漫画阅读的乐趣。',
  },
];